import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Select from 'react-select';
import moment from 'moment';
import _ from 'underscore';
import ReactPaginate from 'react-paginate';
import Modal from 'react-responsive-modal';

import {
    getAllUsersWithProfile,
    setVerifiedToUser,
    setIsActiveToUser,
    addNoteToUser,
    removeNoteFromUser,
} from '../../actions/users_actions';

class UsersListing extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            loaded: false,
            totalPages: 1,
            actualPage: 1,
            perPage: 10,
            filter: {
                email: '',
                name: '',
                lastName: '',
                isActive: true,
            },
            users: null,
            isModalOpen: false,
            modalUser: null,
            modalTextArea: '',
        };

        this.handlePageClick = this.handlePageClick.bind(this);
        this.handlePerPageClick = this.handlePerPageClick.bind(this);
        this.updateFilter = this.updateFilter.bind(this);
        this.createList = this.createList.bind(this);
        this.handleFilterInput = this.handleFilterInput.bind(this);
        this.handleFilterIsActiveSelect = this.handleFilterIsActiveSelect.bind(this);
        this.renderList = this.renderList.bind(this);
    }

    componentWillMount() {
        this.props.getAllUsersWithProfile();
    }

    componentWillReceiveProps(nextProps) {
        const {users} = nextProps;
        if (users && !this.state.loaded) {
            const usersState = this.createList(users, this.state.actualPage, this.state.perPage, this.state.filter);
            this.setState({
                loaded: true,
                users: usersState,
            });
        } else if (nextProps.users) {
            const productsState = this.createList(users, this.state.actualPage, this.state.perPage, this.state.filter);
            this.setState({users: productsState});
        }

        this.setState({
            loaded: true,
        }, this.changePage);
    }

    handlePageClick(data) {
        const actualPage = data.selected + 1;
        const users = this.createList(this.props.users, actualPage, this.state.perPage, this.state.filter);
        this.setState({
            actualPage: data.selected + 1,
            users,
        });
    }

    handlePerPageClick({value}) {
        const users = this.createList(this.props.users, this.state.actualPage, value, this.state.filter);
        this.setState({
            perPage: value,
            users,
        });
    }

    updateFilter(filter) {
        const users = this.createList(this.props.users, this.state.actualPage, this.state.perPage, filter);
        this.setState({
            filter,
            users,
        });
    }

    createList(users, actualPage, perPage, filter) {
        console.log('createList -> prisli')
        console.log(users)
        const list = _.sortBy(users, ({created}) => created * -1);
        const filtredList = list.filter((user) => {
            if (!filter)
                return true;

            const textFilterFun = (value, filterString) => {
                const newValue = value.toLowerCase();
                filterString = filterString.toLowerCase();
                return newValue.indexOf(filterString) > -1;
            };

            let emailBool = true;
            if (filter.email)
                emailBool = textFilterFun(user.email, filter.email);

            let nameBool = true;
            if (filter.name)
                nameBool = textFilterFun(user.name, filter.name);

            let lastNameBool = true;
            if (filter.name)
                lastNameBool = textFilterFun(user.lastName, filter.lastName);

            let isActiveBool = false;
            if (filter.isActive === user.isActive)
                isActiveBool = true;

            return emailBool && nameBool && lastNameBool && isActiveBool;
        });

        const totalPages = Math.ceil(filtredList.length / perPage);
        if (actualPage > totalPages && totalPages !== 0)
            actualPage = totalPages;
        this.setState({
            totalPages,
            actualPage,
        });

        const start = (actualPage - 1) * perPage;
        const end = start + perPage;
        console.log('filtredList > after')
        console.log(filtredList)
        return filtredList.slice(start, end);
    }

    handleFilterInput(event) {
        const filter = this.state.filter;
        filter[event.target.name] = event.target.value;
        this.updateFilter(filter);
    }

    handleFilterIsActiveSelect(option) {
        const filter = this.state.filter;
        filter.isActive = option.value;
        this.updateFilter(filter);
    }

    renderList() {
        return this.state.users.map(user => {
            const criminalRecord = user.criminalRecord ? 'áno' : 'nie';

            let knowBratislava = '';
            switch (user.knowBratislava) {
                case 'yes':
                    knowBratislava = 'Áno';
                    break;
                case 'maybe':
                    knowBratislava = 'Skôr áno ako nie';
                    break;
                case 'no':
                    knowBratislava = 'Nie';
                    break;
            }

            const uberExperienceOptions = [
                {
                    value: 0,
                    label: "Nie, vôbec"
                },
                {
                    value: 10,
                    label: "Áno, do 10 jázd"
                },
                {
                    value: 200,
                    label: "Áno, do 200 jázd"
                },
                {
                    value: 201,
                    label: "Áno, viac ako 200 jázd"
                },
            ];
            const uberExperience = uberExperienceOptions.find(({value}) => (value === user.uberExperience));

            return (
                <tr key={user.key}>
                    <td>{moment(user.created).locale('sk').format('LLL')}</td>
                    <td>{user.email}</td>
                    <td>{user.name}</td>
                    <td>{user.lastName}</td>
                    <td>{user.age}</td>
                    <td>{user.city}</td>
                    <td>{user.telephoneNumber}</td>
                    <td>{user.licenceFromYear}</td>
                    <td>{user.lifetimeKm}</td>
                    <td>
                        {
                            user.hasOwnCar ?
                                <span className="text-success">Áno</span> :
                                <span className="text-danger">Nie</span>
                        }
                    </td>
                    <td>{knowBratislava}</td>
                    <td>{criminalRecord}</td>
                    <td>{user.contractType}</td>
                    <td>{user.fbLink}</td>
                    <td>{uberExperience ? uberExperience.label : ''}</td>
                    <td>
                        <button
                            type="button"
                            className={`btn ${user.verified ? 'btn-success' : 'btn-danger'}`}
                            onClick={() => {
                                this.props.setVerifiedToUser(user, !user.verified);
                            }}
                        >
                            {user.verified ? 'áno' : 'nie'}
                        </button>
                    </td>
                    <td>
                        <button
                            type="button"
                            className={`btn ${user.isActive ? 'btn-success' : 'btn-danger'}`}
                            onClick={() => {
                                this.props.setIsActiveToUser(user, !user.isActive);
                            }}
                        >
                            {user.isActive ? 'áno' : 'nie'}
                        </button>
                    </td>
                    <td>
                        {
                            user.cv &&
                            <a
                                className="btn btn-default"
                                href={user.cv.url}
                                target="_blank"
                                download={`Životopis.${user.cv.extension}`}
                            >
                                Stiahnuť
                            </a>
                        }
                    </td>
                    <td>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                                this.setState({
                                    isModalOpen: true,
                                    modalUser: user,
                                });
                            }}
                        >
                            Poznámky ({user.notes.length})
                        </button>
                    </td>
                </tr>
            );
        });
    }

    render() {
        if (!this.state.loaded)
            return <div className="alert alert-info">Načítam...</div>;

        const {users} = this.state;
        const perPageOptions = [10, 20, 50, 100].map(num => ({
            value: num,
            label: num,
        }));

        return (
            <div>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="panel-title">Použivatelia s profilom</h3>
                    </div>
                    <div className="panel-body">
                        <Modal
                            open={this.state.isModalOpen}
                            onClose={() => {
                                this.setState({isModalOpen: false});
                            }}
                            modalStyle={{maxWidth: '100vw', paddingTop: '35px'}}
                        >
                            <div className="table-responsive">
                                <table className="table table-drop">
                                    <thead>
                                    <tr>
                                        <th>Dátum</th>
                                        <th>Komentár</th>
                                        <th>Odstrániť</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.modalUser &&
                                        this.state.modalUser.notes[0] &&
                                        this.state.modalUser.notes.map((note) => {
                                            return (
                                                <tr key={note.key}>
                                                    <td>{moment(note.dateAdd).locale('sk').format('LLL')}</td>
                                                    <td>{note.text}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={() => {
                                                                this.props.removeNoteFromUser(this.state.modalUser, note);
                                                            }}
                                                        >
                                                            odstrániť
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }
                                    {
                                        this.state.modalUser &&
                                        !this.state.modalUser.notes[0] &&
                                        <tr>
                                            <td colSpan={3}>
                                                <div
                                                    className="alert alert-warning"
                                                >
                                                    Žiadne poznámky...
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-xs-12">
                                <form>
                                    <textarea
                                        className="form-control"
                                        value={this.state.modalTextArea}
                                        onChange={(event) => {
                                            this.setState({modalTextArea: event.target.value})
                                        }}
                                        cols="30"
                                        rows="10"
                                    />
                                    <div className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-default"
                                            onClick={() => {
                                                if (this.state.modalTextArea === '')
                                                    return;

                                                this.setState({modalTextArea: ''});

                                                this.props.addNoteToUser(this.state.modalUser, {
                                                    'dateAdd': Date.now(),
                                                    'text': this.state.modalTextArea,
                                                });
                                            }}
                                        >
                                            Pridať komentár
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </Modal>
                        <div className="row py-1">
                            <div className="col-lg-6 col-xs-12">
                                <div className="per-page">
                                    <span>Na stranu:</span>
                                    <Select
                                        clearable={false}
                                        value={this.state.perPage}
                                        options={perPageOptions}
                                        onChange={this.handlePerPageClick}
                                    />
                                    <span>
                                        {`Celkový počet záznamov:  ${users.length}`}
                                    </span>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xs-12">
                                <ReactPaginate
                                    pageCount={this.state.totalPages}
                                    pageRangeDisplayed={5}
                                    marginPagesDisplayed={2}
                                    onPageChange={this.handlePageClick}
                                    initialPage={this.state.actualPage - 1}
                                    forcePage={this.state.actualPage - 1}
                                    previousLabel={'«'}
                                    nextLabel={'»'}
                                    breakLabel={<a>...</a>}
                                    breakClassName={'break-me'}
                                    containerClassName={'pagination pull-right'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-drop">
                                <thead>
                                <tr>
                                    <th>Dátum</th>
                                    <th>Email</th>
                                    <th>Meno</th>
                                    <th>Priezvisko</th>
                                    <th>Vek</th>
                                    <th>Trvalý pobyt mám v meste (obci)</th>
                                    <th>Telefónne číslo</th>
                                    <th>Vodičský preukaz od roku</th>
                                    <th>Km najazdené do teraz</th>
                                    <th>Má auto</th>
                                    <th>Pozná Bratislavu</th>
                                    <th>Čistý register trestov</th>
                                    <th>Typ spolupráce</th>
                                    <th>FB profil</th>
                                    <th>Máš skúsenosti s Taxify?</th>
                                    <th>Potvrdený</th>
                                    <th>Aktívny</th>
                                    <th>Životopis</th>
                                    <th>Poznámky</th>
                                </tr>
                                <tr>
                                    <th/>
                                    <th>
                                        <input
                                            name="email"
                                            style={{
                                                minWidth: '63px',
                                            }}
                                            value={this.state.filter.email}
                                            className="form-control"
                                            placeholder="email"
                                            onChange={this.handleFilterInput}
                                        />
                                    </th>
                                    <th>
                                        <input
                                            name="name"
                                            style={{
                                                minWidth: '63px',
                                            }}
                                            value={this.state.filter.name}
                                            className="form-control"
                                            placeholder="meno"
                                            onChange={this.handleFilterInput}
                                        />
                                    </th>
                                    <th>
                                        <input
                                            name="lastName"
                                            style={{
                                                minWidth: '94px',
                                            }}
                                            value={this.state.filter.lastName}
                                            className="form-control"
                                            placeholder="priezvisko"
                                            onChange={this.handleFilterInput}
                                        />
                                    </th>
                                    <th colSpan={11}/>
                                    <th>
                                        <Select
                                            style={{
                                                minWidth: '100px',
                                            }}
                                            clearable={false}
                                            value={this.state.filter.isActive}
                                            options={[
                                                {
                                                    label: 'aktívny',
                                                    value: true,
                                                },
                                                {
                                                    label: 'neaktívny',
                                                    value: false,
                                                },
                                            ]}
                                            onChange={this.handleFilterIsActiveSelect}
                                        />
                                    </th>
                                    <th colSpan={2}/>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.users &&
                                    this.renderList()
                                }
                                {
                                    this.state.users &&
                                    this.state.users.length === 0 &&
                                    <tr>
                                        <td colSpan={18}>
                                            <div
                                                className="alert alert-warning"
                                            >
                                                Žiadne záznamy...
                                            </div>
                                        </td>
                                    </tr>
                                }
                                </tbody>
                            </table>
                        </div>
                        <div className="row py-1">
                            <div className="col-lg-6 col-xs-12">
                                <div className="per-page">
                                    <span>Na stranu: </span>
                                    <Select
                                        clearable={false}
                                        value={this.state.perPage}
                                        options={perPageOptions}
                                        onChange={this.handlePerPageClick}
                                    />
                                    <span>
                                        {`Celkový počet záznamov:  ${users.length}`}
                                    </span>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xs-12">
                                <ReactPaginate
                                    pageCount={this.state.totalPages}
                                    pageRangeDisplayed={5}
                                    marginPagesDisplayed={2}
                                    onPageChange={this.handlePageClick}
                                    initialPage={this.state.actualPage - 1}
                                    forcePage={this.state.actualPage - 1}
                                    previousLabel={'«'}
                                    nextLabel={'»'}
                                    breakLabel={<a>...</a>}
                                    breakClassName={'break-me'}
                                    containerClassName={'pagination pull-right'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAllUsersWithProfile,
        setVerifiedToUser,
        setIsActiveToUser,
        addNoteToUser,
        removeNoteFromUser,
    }, dispatch);
}

function mapStateToProps({users}) {
    return {users};
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersListing);



// WEBPACK FOOTER //
// ./src/app/components/users/usersListing.jsx